
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import { defineComponent } from "vue";
import useOrder from '@/modules/useOrder';

export default defineComponent({
  components: { BackAndCancelFooter },
  async setup() {
    const { openCashDrawerPrinter } = useOrder();
    return {openCashDrawerPrinter};
  },
});
